import { graphql } from "@/graphql/codegen"

export const UpdateContactLocationMutation = graphql(`
  mutation UpdateContactLocation($input: ContactLocationUpdateInput!) {
    contact {
      updateContactLocation(input: $input) {
        ... on ContactLocationUpdateSuccess {
          contactLocationAssociation {
            contactLocationId
            isPrimary
            contactId
            locationId
            contactRole
            location {
              locationId
              name
              address1
              city
              regionIsoCode
              primaryContact {
                contactId
                firstName
                lastName
              }
            }
          }
        }
        ... on ContactLocationUpdateFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
